import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../infra/hooks";

const DTOUpdatePasswordModal = () => {
  return <></>;
};
export default DTOUpdatePasswordModal;
